import { useCallback, useEffect, useState } from "react";
import http from "../../../../http";
import { useRecarregaAoRenovarToken } from "../../../../modules/shared/hooks/useRecarregaAoRenovarToken";

export const useBuscaNumeroOcorrencias = () => {
    const [totalOcorrencias, setTotalOcorrencias] = useState('')

    const buscaNumeroOcorrencias = useCallback(() => {
        http.get('/nr-ocorrencias-totais', )
        .then(res => {
            const nrTotalOcorrencias = res.data
            setTotalOcorrencias(nrTotalOcorrencias)
        })
        .catch(() => setTotalOcorrencias(''))
    }, [])

    useEffect(() => {
        buscaNumeroOcorrencias()
    }, [buscaNumeroOcorrencias])

    useRecarregaAoRenovarToken(buscaNumeroOcorrencias)

    return {
        totalOcorrencias
    }
}
